import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFeaturedMovies,
  addToWatchlist,
} from "../../redux/actions/movieActions";
import { Link } from "react-router-dom";
import { AiFillStar } from "react-icons/ai";
import { RiBookmark3Fill } from "react-icons/ri";
import fullDate from "../DateFunction";
import rating from "../RatingFunctiion";

const FeaturedMovie = () => {
  const featured = useSelector((state) => state.featuredMovies.featured);
  // const badge = useSelector((state) => state.watchlistMovie.watchlist.payload.badge);
  // console.log(badge)
  const badge = false;
  const dispatch = useDispatch();

  const getFeaturedMovieRequest = async () => {
    const url = `https://api.themoviedb.org/3/movie/popular?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1`;
    const response = await fetch(url);
    const infoData = await response.json();
    dispatch(setFeaturedMovies(infoData.results));
  };

  useEffect(() => {
    getFeaturedMovieRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const vw = Math.floor((window.innerWidth / 245) * 2);
  const vw = () => {
    const size = Math.floor((window.innerWidth / 245) * 2);
    console.log(size);

    if (window.innerWidth <= 500) {
      return 4;
    } else if (window.innerWidth <= 700) {
      return 6;
    } else if (size % 2 !== 0) {
      return size - 1;
    } else {
      return size;
    }
  };

  return (
    <>
      {
        //Alternative filter
        //infos.filter((info, idx) => idx < infos.length).map
        featured.slice(0, vw()).map((info) => (
          <div className="featured-movie" key={info.id}>
            <div className="featured-movie-img-container">
              <RiBookmark3Fill
                className={
                  badge ? "featured-book-icon active" : "featured-book-icon"
                }
                onClick={() => dispatch(addToWatchlist(info))}
              />
              <Link to={`/movie/${info.id}`}>
                <img
                  src={`https://image.tmdb.org/t/p/original${info.poster_path}`}
                  alt={info.title}
                  className="featured-movie-img"
                />
              </Link>
            </div>
            <div className="featured-movie-info">
              <div className="feature-title-container">
                <h2 className="feature-title">
                  {info.title.length < 26
                    ? info.title
                    : `${info.title.substring(0, 26)}...`}
                </h2>
                <span>
                  {rating(info.vote_average)} <AiFillStar />
                </span>
              </div>
              <p className="release-date">
                Released: {fullDate(info.release_date)}
              </p>
              <div className="featured-movie-buttons">
                {/* <Link to={`/movie/${info.id}`} className="featured-movie-button"><AiFillPlayCircle className="feature-play-icon" /> watch trailer</Link> */}
                <Link
                  to={`/movie/${info.id}`}
                  className="featured-movie-button"
                >
                  more details
                </Link>
              </div>
            </div>
          </div>
        ))
      }
    </>
  );
};

export default FeaturedMovie;
